import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { Label, Checkbox } from "../../../components/base";
import { FieldDescription } from "../FieldDescription";
export const CheckboxField = ({ field, value, disabled, error, onChange, }) => {
    const uniqueId = useId();
    const options = field.options ?? [];
    const selected = Array.isArray(value) ? value : [];
    const toggle = (optValue) => {
        const next = selected.includes(optValue)
            ? selected.filter((v) => v !== optValue)
            : [...selected, optValue];
        onChange?.(next);
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsx("div", { className: `space-y-2 ${error ? "rounded-md border border-red-500 p-2" : ""}`, children: options.map((opt, idx) => {
                    const optionId = `${uniqueId}-${field.name}-${opt.value || idx}`;
                    const checked = selected.includes(opt.value);
                    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Checkbox, { id: optionId, checked: checked, onCheckedChange: () => toggle(opt.value), disabled: disabled }), _jsx(Label, { htmlFor: optionId, className: "text-sm font-normal", children: opt.label })] }, opt.value || idx));
                }) }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateCheckboxField = (field, value, t) => {
    if (!field.required)
        return undefined;
    const arr = Array.isArray(value) ? value : [];
    if (arr.length === 0) {
        return t("form.validation.checkboxRequired");
    }
    return undefined;
};
export const serializeCheckboxField = (field, value) => {
    const arr = Array.isArray(value) ? value : [];
    if (arr.length === 0)
        return undefined;
    const options = Array.isArray(field.options) ? field.options : [];
    const mapped = arr.map((v) => {
        const found = options.find((o) => o.value === v);
        return found ? found.label : v;
    });
    return mapped.length > 0 ? mapped : undefined;
};
//# sourceMappingURL=CheckboxField.js.map